import Cookies from 'js-cookie'
import { cvRefreshTokenCookieName, fbLoginCookie, userSessionCookie } from './auth.constants'
import { AuthProviderFactory, getCvUserFromIdToken } from 'react-ai-platform-auth'
import { ICvUser, ICvUserExtended, CookieSyncOptions } from './auth.types'
import { getUrlParameter, setCookie } from '../common/common.utils'
import { authConfig, refreshTokenCookieDomain } from './auth.config'

export function initializeCookieSync({ onReady }: CookieSyncOptions = {}): {
    isReady: () => boolean
    cleanup: () => void
} {
    let isReady = false
    const rtParam = getUrlParameter('rt')

    if (rtParam) {
        setCookie('rt_cv', rtParam, refreshTokenCookieDomain)
        const currentUrl = new URL(window.location.href)

        currentUrl.searchParams.delete('rt')
        const cleanUrl = currentUrl.toString()

        window.history.replaceState({}, document.title, cleanUrl)
    }

    isReady = true
    onReady?.()

    return {
        isReady: () => isReady,
        cleanup: () => {},
    }
}

export const verifyRefreshToken = () => {
    try {
        const refreshToken = Cookies.get(cvRefreshTokenCookieName)

        if (!refreshToken) {
            const urlParams = new URLSearchParams(window.location.search)
            if (urlParams.has('rt')) {
                throw new Error()
            }

            const redirectUrl = authConfig.defaultLogoutRedirectUrl
            window.location.replace(redirectUrl)
        }
    } catch {
        console.error('not authorized')
    }
}

export const getBearerToken = () => {
    try {
        verifyRefreshToken()
        return `Bearer ${JSON.parse(Cookies.get(userSessionCookie) ?? '').token}`
    } catch (e) {
        console.log('not authorized')
    }
    return null
}
export const validateUserSession = getBearerToken

export const deleteLocalSession = () => {
    Cookies.remove(userSessionCookie)
    Cookies.remove(fbLoginCookie)
}

export function transformCvUser(input: ICvUserExtended | null): ICvUser | null {
    if (input === null) {
        return null
    }
    return {
        first_name: input.firstName ?? '',
        is_activated: input.isActivated,
        last_name: input.lastName ?? '',
        organizations: [{ id: input.organizations.id, org_type: input.organizations.org_type }],
        rbac2_roles: input.rbac2Roles.map(role => role),
        require_mfa: input.requireMfa,
        roles: input.roles.map(role => role),
        state: input.state,
        status: input.status,
        token: input.token,
        user_id: input.userId,
        email: input.email,
    }
}

export function getCvUserFromIdTokenExtended(idToken: string): ICvUserExtended | null {
    const user = getCvUserFromIdToken(idToken) as ICvUserExtended
    return user || null
}

export const { AuthProvider, Authenticate, Authorize, withAuthorize, useAuthContext } =
    AuthProviderFactory(getCvUserFromIdTokenExtended)
